import { FC, memo } from 'react';
import styles from './product-fees.module.scss';
import { readablePrice } from '../../helper';

interface IProductServiceFee {
  key: string;
  /**
   * The title of the service fee. This can be either a plain string or a React element
   * to allow for more complex rendering scenarios.
  */
  title: string | React.ReactElement;
  value: number;
}

export interface IProductFees {
  serviceFees: IProductServiceFee[];
  translations: {
    serviceFeeTitle: string;
  }
}

export const ProductFeesComponent: FC<IProductFees> = ({ serviceFees, translations }) => {

  if (serviceFees.length === 0) {
    return null;
  }

  return (
    <div className={styles.productFeesContainer}>
      <p className={styles.title}>{translations.serviceFeeTitle}</p>
      {serviceFees.map((fee) => (
        <div className={styles.feeContainer} key={fee.key}>
          <p className={styles.feeTitle}>{fee.title}</p>
          <p className={styles.feeValue}>{readablePrice(fee.value)}</p>
        </div>
      ))}
    </div>
  );
};

export const ProductFees = memo(ProductFeesComponent);
